"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deriveProductName = exports.isOrderManagementAction = exports.processBFFDataRequested = exports.createErrorObject = exports.graphRequestToCheggResponse = exports.sendBFFCall = void 0;
var tslib_1 = require("tslib");
var GraphApi_1 = tslib_1.__importDefault(require("../../API/GraphApi"));
var InternalGraphApi_1 = tslib_1.__importDefault(require("../../API/InternalGraphApi"));
var constants_1 = require("../authorize/constants");
var interfaces_1 = require("./interfaces");
function sendBFFCall(operationName, data, dataTransformer, mappedOperationNames, timeout, internalRequestPayload, logError) {
    var response;
    if (internalRequestPayload && internalRequestPayload.isInternal) {
        response = InternalGraphApi_1.default.doFetchPersistedQuery(operationName, internalRequestPayload, data, timeout, logError).then(function (result) {
            return result;
        });
    }
    else {
        response = GraphApi_1.default.doFetchPersistedQuery(operationName, data, timeout, logError).then(function (result) {
            return result;
        });
    }
    return dataTransformer
        ? dataTransformer(graphRequestToCheggResponse(response, operationName, mappedOperationNames))
        : graphRequestToCheggResponse(response, operationName, mappedOperationNames);
}
exports.sendBFFCall = sendBFFCall;
function graphRequestToCheggResponse(responseParams, operationName, mappedOperationNames) {
    return responseParams.then(function (_a) {
        var e_1, _b, e_2, _c;
        var _d, _e;
        var _f = _a.data, graphQLData = _f.data, errors = _f.errors;
        var success = true;
        var extractedData = null;
        if (graphQLData) {
            if (interfaces_1.SKIP_OPERATION_NAME_CHECK.includes(operationName)) {
                extractedData = graphQLData;
            }
            else if (graphQLData[operationName]) {
                extractedData = graphQLData[operationName];
            }
            else if (mappedOperationNames) {
                try {
                    for (var mappedOperationNames_1 = tslib_1.__values(mappedOperationNames), mappedOperationNames_1_1 = mappedOperationNames_1.next(); !mappedOperationNames_1_1.done; mappedOperationNames_1_1 = mappedOperationNames_1.next()) {
                        var mappedOperationName = mappedOperationNames_1_1.value;
                        if (graphQLData[mappedOperationName]) {
                            extractedData = graphQLData[mappedOperationName];
                        }
                    }
                }
                catch (e_1_1) { e_1 = { error: e_1_1 }; }
                finally {
                    try {
                        if (mappedOperationNames_1_1 && !mappedOperationNames_1_1.done && (_b = mappedOperationNames_1.return)) _b.call(mappedOperationNames_1);
                    }
                    finally { if (e_1) throw e_1.error; }
                }
            }
        }
        if (errors) {
            var resolvedError = constants_1.AuthorizeErrors.UNKNOWN_FAILURE;
            try {
                for (var _g = tslib_1.__values(errors), _h = _g.next(); !_h.done; _h = _g.next()) {
                    var error = _h.value;
                    var errorCode = (_e = (_d = error.extensions) === null || _d === void 0 ? void 0 : _d.code) !== null && _e !== void 0 ? _e : "";
                    if (errorCode in interfaces_1.GRAPHQL_AUTHENTICATION_ERRORS) {
                        resolvedError = constants_1.AuthorizeErrors.AUTHORIZE_FAILURE;
                        resolvedError.originalError = error;
                        break;
                    }
                    else if (errorCode in interfaces_1.GRAPHQL_BAD_REQUEST_ERRORS) {
                        resolvedError = constants_1.AuthorizeErrors.BAD_REQUEST;
                        resolvedError.originalError = error;
                        break;
                    }
                    else {
                        resolvedError = constants_1.AuthorizeErrors.UNKNOWN_FAILURE;
                        resolvedError.originalError = error;
                    }
                }
            }
            catch (e_2_1) { e_2 = { error: e_2_1 }; }
            finally {
                try {
                    if (_h && !_h.done && (_c = _g.return)) _c.call(_g);
                }
                finally { if (e_2) throw e_2.error; }
            }
            errors = [resolvedError];
            success = false;
        }
        var response = {
            data: extractedData,
            errors: errors || null,
            success: success,
        };
        if (!success) {
            throw new Error(JSON.stringify(response));
        }
        return response;
    });
}
exports.graphRequestToCheggResponse = graphRequestToCheggResponse;
function createErrorObject(error, message) {
    return [
        {
            code: error,
            message: message,
            type: interfaces_1.ErrorType.SERVER,
        },
    ];
}
exports.createErrorObject = createErrorObject;
function processBFFDataRequested(dataRequested) {
    var dataRequestedList = [];
    var desiredOrderStatuses = [];
    dataRequested.split(",").forEach(function (dataRequest) {
        dataRequest = dataRequest.toLowerCase();
        if (dataRequest.includes("eligibility")) {
            dataRequestedList.push("eligibility");
        }
        if (dataRequest.includes("vpn")) {
            dataRequestedList.push("vpnCheck");
        }
        if (dataRequest.includes("orderdetails")) {
            dataRequestedList.push("orderDetails");
            if (dataRequest.includes("pendingcancel")) {
                desiredOrderStatuses.push(interfaces_1.OrderStates.PENDING_CANCEL);
            }
            if (dataRequest.includes("paused")) {
                desiredOrderStatuses.push(interfaces_1.OrderStates.PAUSED);
            }
            if (dataRequest.includes("pendingpause")) {
                desiredOrderStatuses.push(interfaces_1.OrderStates.PENDING_PAUSE);
            }
            if (dataRequest.includes("allstate")) {
                desiredOrderStatuses.push(interfaces_1.OrderStates.PENDING_PAUSE, interfaces_1.OrderStates.PAUSED, interfaces_1.OrderStates.PENDING_CANCEL);
            }
        }
        if (dataRequest.includes("mopdetails")) {
            dataRequestedList.push("mopDetails");
        }
        if (dataRequest.includes("tax")) {
            dataRequestedList.push("tax");
        }
        if (dataRequest.includes("authstate")) {
            dataRequestedList.push("getAuthState");
        }
        if (dataRequest.includes("linksharingabusecheck")) {
            dataRequestedList.push("linkSharingAbuseCheck");
        }
    });
    return {
        dataRequested: dataRequestedList.join(","),
        desiredOrderStatuses: desiredOrderStatuses,
    };
}
exports.processBFFDataRequested = processBFFDataRequested;
var isOrderManagementAction = function (finalActions) {
    return (finalActions.filter(function (actionName) {
        return [
            "REVOKE_PENDING_CANCEL",
            "REVOKE_PENDING_PAUSE",
            "RESUME",
        ].includes(actionName);
    }).length > 0);
};
exports.isOrderManagementAction = isOrderManagementAction;
var deriveProductName = function (productName) {
    var finalProductName = productName;
    if (productName.toString() === interfaces_1.ProductType.CHEGG_STUDY_PACK) {
        finalProductName = interfaces_1.ProductName.CHEGG_STUDY_PACK;
    }
    return finalProductName;
};
exports.deriveProductName = deriveProductName;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/pricing-sdk/dist/lib-esm/modules/common/index.js
// module id = 627
// module chunks = 11